import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { CardTableComponent } from 'libs/portal/src/modules/tools/card-table/components';
import { CardTableAction, CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { Endpoints, Routes } from '@huge-monorepo/portal/config';
import { LocationRadiusModalComponent } from '../../../components/location-radius-modal/location-radius-modal/location-radius-modal.component';
import { GenericTableHeaderOptions, RefreshData } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { MatDialog } from '@angular/material/dialog';
import { MemoryService } from '@huge-monorepo/portal/services';

export interface Device {
  name: string;
  log: string;
  content: string;
  selected: boolean;
}

@Component({
  selector: 'app-device-logs',
  templateUrl: './device-logs.component.html',
  styleUrls: ['./device-logs.component.scss'],
})
export class DeviceLogsComponent implements OnInit {
  @ViewChild('sticky') sticky: TemplateRef<any>;
  @ViewChild('RFATable', { static: false }) public RFATable: CardTableComponent;
  totalRingFenceAlerts: number;
  loadingRingFenceAlerts = false;
  loadingError = false;
  orderBy = 'Timestamp';
  tableCount = 10;
  search = '';
  tableOffset = 0;
  currentPage = 1;
  defaultRingFence = 5;
  desc = true;
  firstLoad = true;
  ScreenSize = ScreenSize;
  data: Device[] = [];

  getRingFenceAlertsRequestBody = {
    DeviceID: null,
    KADeviceID: null,
    GroupID: null,
  };

  options: CardTableOptions = {
    rowId: 'id',
    titleProperty: 'terminalid',
    subTitleProperty: 'locationStatus',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['accepted', 'alertid', 'color', 'imei', 'selected', 'location', 'id', 'data', 'description', 'cdrdeviceid'],
    stylePropertyPrefix: 'logs',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchPlaceholder: 'Search',
    DefaultSort: 'Timestamp',
    DefaultDesc: true,
    SortItems: [
      {
        Name: 'Timestamp',
        Display: 'Timestamp',
      },
      {
        Name: 'AcceptedBy',
        Display: 'Accepted By',
      },
      {
        Name: 'TimeAccepted',
        Display: 'Accepted On',
      },
    ],
  };

  headers: CardTableHeader[] = [
    {
      ID: 'terminalid',
      Text: 'Terminal ID',
      Width: 14,
    },
    {
      ID: 'devicenum',
      Text: 'CDR #',
      Width: 12,
    },
    {
      ID: 'locationStatus',
      Text: 'Breach',
      Width: 10,
    },
    {
      ID: 'timestamp',
      Text: 'Timestamp',
      Width: 15,
    },
    {
      ID: 'acceptedBy',
      Text: 'Accepted By',
      Width: 20,
    },
    {
      ID: 'timeAccepted',
      Text: 'Accepted On',
      Width: 15,
    },
  ];

  listActions = [
    {
      title: 'View Device',
      iconSrc: 'assets/icon/devices.svg',
      color: 'primary',
      showIcon: true,
    },
    {
      title: 'View Alert Location',
      iconSrc: 'assets/icon/map.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  rowActions: CardTableAction[] = [
    {
      title: 'Accept location',
      iconSrc: 'assets/icon/check-square-regular.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  acceptedRowActions: CardTableAction[] = [
    {
      title: 'Accept location',
      iconSrc: 'assets/icon/check-square-regular.svg',
      color: 'primary',
      showIcon: true,
      display: false,
    },
  ];

  constructor(
    private titleService: TitleService,
    private navigationService: NavigationService,
    private layoutService: LayoutService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private paginationService: PaginationService,
    private router: Router,
    private dialog: MatDialog,
    private memory: MemoryService,
    private routeDictionary: Routes,
  ) {}

  ngAfterViewInit(): void {
    this.titleService.pageTitle = 'Ringfence Alerts';
    this.layoutService.addStickyHeaderForRoute(this.navigationService.GetCurrentRoute(), this.sticky);
  }

  getLatestRingFence(device: any, eve: any) {
    this.genericService.GET(this.endpoints.GET_LATEST_RING_FENCE_LOG(device.id), true).subscribe((results) => {
      const data = results['body'];
      console.log('data', data, device);
      this.openLocationRadiusModal(device, data != null && data.Radius != null ? data.Radius / 1000 : this.defaultRingFence, eve);
    });
  }

  refreshData(data: RefreshData): void {
    this.search = data.Search ?? '';
    this.desc = data.Desc ?? this.desc;
    this.orderBy = data.Sort ?? '';
    this.tableOffset = 0;
    this.currentPage = 1;
    this.getRingFenceAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc);
  }

  async openLocationRadiusModal(device: any, currentRingFenceValue: number, eve: any) {
    const dialogRef = this.dialog.open(LocationRadiusModalComponent, {
      data: {
        celltower: device.data.TowerID,
        currentRingFenceValue: currentRingFenceValue,
        deviceIds: [device.id],
        alertid: device.alertid,
        device: {
          imei: device.imei,
          terminalid: device.terminalid,
          location: {
            lat: device.location.lat,
            lng: device.location.lng,
          },
          data: device.data,
        },
        description: device.description,
      },
      hasBackdrop: false,
    });

    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (dataReturned) => {
        if (dataReturned != null && dataReturned.data != null) {
          this.getRingFenceAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc);
        }
        dialogSub.unsubscribe();
      },
    });
  }

  setRFATableToRefreshing() {
    setTimeout(() => {
      if (this.RFATable) {
        this.RFATable.StartRefresh();
      }
    });
  }

  setRFATableToFinished() {
    setTimeout(() => {
      if (this.RFATable) {
        this.RFATable.EndRefresh();
      }
    });
  }

  formatLocationStatus(distance: number, radius: number) {
    return `${((distance - radius) / 1000).toFixed(2)}km`;
  }

  getRingFenceAlerts(orderBy: string, search: string, count: number, offset: number, desc: boolean) {
    this.loadingRingFenceAlerts = true;
    this.setRFATableToRefreshing();
    this.loadingError = false;
    this.genericService.POST(this.endpoints.GET_RING_FENCE_ALERTS(count, offset, search, orderBy, desc), this.getRingFenceAlertsRequestBody).subscribe(
      (resp: Object) => {
        const ringFenceAlerts = resp['body'];
        if (ringFenceAlerts != null) {
          const tmpData = [];
          ringFenceAlerts.forEach((element) => {
            const ob = {
              id: element.KADeviceID,
              terminalid: element.KADevice.TerminalID,
              data: element.Data,
              description: element.Description,
              imei: element.KADevice.imei,
              cdrdeviceid: element.KADevice.CDRDeviceID != null ? element.KADevice.CDRDeviceID : '',
              devicenum: element.KADevice.DeviceNum != null ? element.KADevice.DeviceNum : '',
              locationStatus: this.formatLocationStatus(element.Data.Distance, element.Data.Radius),
              timestamp: this.tools.FormatDateTime(this.tools.ParseAPIDate(element.Timestamp)),
              location: element.Location,
              selected: false,
              accepted: element.Accepted,
              color: element.Accepted ? '#3FC944' : '#C96D01',
              acceptedBy: element.AcceptedBy != null ? element.AcceptedBy : 'N/A',
              timeAccepted: element.TimeAccepted == null ? '' : this.tools.FormatDateTime(this.tools.ParseAPIDate(element.TimeAccepted)),
              alertid: element.ID,
            };

            if (ob.devicenum == '' || ob.devicenum == null) {
              ob.devicenum = '';
            }

            tmpData.push(ob);
          });
          this.data = tmpData;
        } else {
          this.data = [];
        }

        this.totalRingFenceAlerts = this.tools.ExtractPaginationFromHeaders(resp['headers']);

        setTimeout(() => {
          this.loadingRingFenceAlerts = false;
          this.setRFATableToFinished();
          this.firstLoad = false;
          this.paginationService.emit();
        });
      },
      () => {
        this.loadingRingFenceAlerts = false;
        this.setRFATableToFinished();
        this.firstLoad = false;
        this.paginationService.emit();
        this.loadingError = true;
      },
    );
  }

  getPagedAlerts(pageIndex: number) {
    this.tableOffset = (pageIndex - 1) * this.tableCount;
    this.currentPage = pageIndex;
    this.getRingFenceAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc);
  }

  loadMoreData($event: any) {
    setTimeout(() => {
      $event.target.complete();

      // App logic to determine if all data is loaded
      // and disable the infinite scroll
      if (this.data.length > 4) {
        $event.target.disabled = true;
      }
    }, 500);
  }

  onAction($event: any) {
    if ($event.title == 'Accept location') {
      this.getLatestRingFence($event.row, $event);
    } else if ($event.title == 'View Device') {
      this.memory.setDetails(false, this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc);
      this.router.navigate([this.routeDictionary.KeepAliveDeviceDetails], {
        state: {
          data: {
            CdrID: $event.row.cdrdevice_id,
            KaID: $event.row.id,
          },
        },
      });
    } else if ($event.title == 'View Alert Location') {
      this.openAlertLocationModal($event);
    }
  }

  ngOnInit() {
    this.getRingFenceAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc);
  }

  async openAlertLocationModal(event) {
    const device = event.row;

    const dialogRef = this.dialog.open(LocationRadiusModalComponent, {
      data: {
        currentRingFenceValue: device.data.Radius / 1000,
        accepted: device.accepted,
        deviceIds: [device.id],
        device: {
          imei: device.imei,
          terminalid: device.terminalid,
          location: {
            lat: device.location.lat,
            lng: device.location.lng,
          },
          data: device.data,
        },
        description: device.description,
        viewOnly: true,
      },
      hasBackdrop: false,
    });

    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (dataReturned) => {
        if (dataReturned != null && dataReturned.data != null) {
          this.getRingFenceAlerts(this.orderBy, this.search, this.tableCount, this.tableOffset, this.desc);
        }
        dialogSub.unsubscribe();
      },
    });
  }
}
